<template>
  <div class="content">

    <div v-if="!$store.state.bpo2.inputs.rents.length">
      <div class="column">

        <div class="tile">
          <div class="tile is-parent is-vertical">

            <article class="tile is-child notification is-warning">
              <p class="subtitle">After you input the rents then a Price Opinion will be created</p>
            </article>

          </div>

        </div>
      </div>
    </div>

    <div
      class="columns"
      v-if="$store.state.bpo2.inputs.rents.length"
    >

      <div class="column">

        <div class="tile">
          <div class="tile is-parent is-vertical">

            <article class="tile is-child notification">
              <p class="subtitle">Property Address</p>
              <p>{{ $store.state.property.address }}<br />{{ $store.state.property.city }}, {{ $store.state.property.state }} {{ $store.state.property.zip }}</p>
            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Scheduled Rents</p>

              <table>
                <tr>
                  <td class="header">Type</td>
                  <td class="header align-center">#</td>
                  <td class="header align-center">Scheduled Rent</td>
                  <td class="header align-center">Sqft</td>
                  <td class="header align-center">$/Sqft</td>
                  <td class="header align-center">Monthly $</td>
                  <td class="header align-center">Annually $</td>
                </tr>

                <tr
                  v-for="(line, index) in $store.state.bpo2.outputs.rents"
                  v-bind:key="index"
                  class="row"
                >
                  <td>{{ line.type }}</td>
                  <td class="align-center">{{ line.unitCount }}</td>
                  <td class="align-center">{{ line.currentRent | currency(0) }}</td>
                  <td class="align-center">{{ line.sqft | number(0) }}</td>
                  <td class="align-center">{{ line.currentPricePerSqft | currency(2) }}</td>
                  <td class="align-center">{{ line.currentMonthly | currency(0) }}</td>
                  <td class="align-center">{{ line.currentAnnual | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td class="footer align-center"></td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalUnitCount_R23 }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalCurrentRent_S23 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalSqft_T23 | number(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalCurrentPricePerSqft_U23 | currency(2) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalCurrentMonthly_V23 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalCurrentAnnual_W23 | currency(0) }}</td>
                </tr>

              </table>

            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Proforma Rents</p>

              <table>
                <tr>
                  <td class="header">Type</td>
                  <td class="header align-center">#</td>
                  <td class="header align-center">Proforma Rent</td>
                  <td class="header align-center">Sqft</td>
                  <td class="header align-center">$/Sqft</td>
                  <td class="header align-center">Monthly $</td>
                  <td class="header align-center">Annually $</td>
                </tr>

                <tr
                  v-for="(line, index) in $store.state.bpo2.outputs.rents"
                  v-bind:key="index"
                  class="row"
                >
                  <td>{{ line.type }}</td>
                  <td class="align-center">{{ line.unitCount }}</td>
                  <td class="align-center">{{ line.proformaRent | currency(0) }}</td>
                  <td class="align-center">{{ line.sqft }}</td>
                  <td class="align-center">{{ line.proformaPricePerSqft | currency(2) }}</td>
                  <td class="align-center">{{ line.proformaMonthly | currency(0) }}</td>
                  <td class="align-center">{{ line.proformaAnnual | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td class="footer align-center"></td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalUnitCount_R23 }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalProformaRent_S37 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalSqft_T23 | number(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalProformaPricePerSqft_U37 | currency(2) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalProformaMonthly_V37 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.totalProformaAnnual_W37 | currency(0) }}</td>
                </tr>

              </table>

            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Deal Terms</p>

              <table>

                <tr>
                  <td>Asking Price</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.askingPrice_J18 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.askingPricePerUnit_K18 | currency(0) }} per unit</td>
                </tr>

                <tr>
                  <td>Offer Price</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.offerPrice_J19 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.offerPricePerUnit_K19 | currency(0) }} per unit</td>
                </tr>

                <tr>
                  <td>Rehab - In Loan</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.rehabInLoan_J20 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.rehabInLoanPerUnit_K20 | currency(0) }} per unit</td>
                </tr>

                <tr>
                  <td>Total "In"</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.totalIn_J21 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Closing & Startup Costs</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.closingAndStartupCosts_J22 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.closingAndStartupCostsPercent_I22 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>Operating Capital</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.operatingCapital_J23 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Rehab - Not In Loan</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.rehabNotInLoan_J24 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Prepaid Expenses and Deposits</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.prepaidExpensesAndDeposits_J25 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Total Out Of Pocket</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.totalOutOfPocket_J26 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td># of Units</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.numberOfUnits_J28 }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Total "In" $/Unit</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.totalInPricePerUnit_J29 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Down Payment</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.downPayment_K30 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.downPaymentPercent_J30 | percent(0) }}</td>
                </tr>

                <tr>
                  <td>Loan Amount</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.loanAmount_J31 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Interest Rate</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.interestRate_J32 | percent(2) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Terms in Years</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.termInYears_J33 }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Interest Only Period in Years</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.interestOnlyPeriodInYears_J34 | number(2) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>% of Rehab to be Financed</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.percentOfRehabToBeFinanced_J35 | percent(0) }}</td>
                  <td></td>
                </tr>

              </table>

            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Income and Expense Changes</p>

              <table>

                <tr>
                  <td class="align-center">Proforma Year 2<br>Income Change</td>
                  <td class="align-center">Proforma Year 2<br> Expense Change</td>
                  <td class="align-center">Proforma Year 3<br>Income Change</td>
                  <td class="align-center">Proforma Year 3<br>Expense Change</td>
                </tr>

                <tr>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformaYear2IncomeChange_N32 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformaYear2ExpenseChange_N33 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformaYear3IncomeChange_N34 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformaYear3ExpenseChange_N35 | percent(1) }}</td>
                </tr>

              </table>

            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Operating Expenses</p>

              <p>[NAA Market Data for {{ $store.state.bpo2.outputs.naaSurvey.marketDescription }}]</p>

              <table>

                <tr>
                  <td class="operating-expenses-columns-header align-left">Category</td>
                  <td class="operating-expenses-columns-header">{{ $store.state.bpo2.outputs.actuals.label_J38 }}<br />$</td>
                  <td class="operating-expenses-columns-header">{{ $store.state.bpo2.outputs.actuals.label_J38 }}<br />$/Unit</td>
                  <td class="operating-expenses-columns-header">{{ $store.state.bpo2.outputs.brokers.label_K38 }}<br />$</td>
                  <td class="operating-expenses-columns-header">{{ $store.state.bpo2.outputs.brokers.label_K38 }}<br />$/Unit</td>
                  <td class="operating-expenses-columns-header">NAA<br />$/Unit</td>
                </tr>

                <tr
                  v-for="(item, index) in $store.state.bpo2.outputs.operatingExpenses.operatingExpenses"
                  :key="index"
                >
                  <td>{{ item.name }}</td>
                  <td class="align-center">{{ item.amountActual | currency(0) }}</td>
                  <td class="align-center">{{ item.amountActualPerUnit | currency(0) }}</td>
                  <td class="align-center">{{ item.amountProforma | currency(0) }}</td>
                  <td class="align-center">{{ item.amountProformaPerUnit | currency(0) }}</td>
                  <td class="align-center">{{ item.amountNaaPerUnit | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td class="footer align-center"></td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.operatingExpenses.totalActual_S57 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.operatingExpenses.totalActualPerUnit_T57 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.operatingExpenses.totalProforma_U57 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.operatingExpenses.totalProformaPerUnit_V57 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo2.outputs.operatingExpenses.totalNaaSurveyPerUnit_W57 | currency(0) }}</td>
                </tr>

              </table>

            </article>

            <article class="tile is-child notification">

              <div class="columns">

                <div class="column">

                  <!-- CAPITAL IMPROVEMENTS -->
                  <p class="subtitle">Capital Improvements</p>

                  <table>

                    <tr
                      v-for="(item, index) in $store.state.bpo2.outputs.capitalImprovements.capitalImprovements"
                      :key="index"
                    >
                      <td>{{ item.name }}</td>
                      <td class="align-center">{{ item.amount | currency(0) }}</td>
                    </tr>

                    <tr class="subtotal1">
                      <td class="footer align-center"></td>
                      <td class="footer align-center">{{ $store.state.bpo2.outputs.capitalImprovements.total_S89 | currency(0) }}</td>
                    </tr>

                  </table>
                  <!-- CAPITAL IMPROVEMENTS -->

                </div>

                <div class="column">

                  <!-- CLOSING COSTS -->
                  <p class="subtitle">Closing Costs</p>

                  <table>

                    <tr
                      v-for="(item, index) in $store.state.bpo2.outputs.closingCosts.closingCosts"
                      :key="index"
                    >
                      <td>{{ item.name }}</td>
                      <td class="align-center">{{ item.amount | currency(0) }}</td>
                    </tr>

                    <tr class="subtotal1">
                      <td class="footer align-center"></td>
                      <td class="footer align-center">{{ $store.state.bpo2.outputs.closingCosts.total_W68 | currency(0) }}</td>
                    </tr>

                  </table>
                  <!-- CLOSING COSTS -->

                  <!-- STARTUP COSTS -->
                  <p class="subtitle">Startup Costs</p>

                  <table>

                    <tr
                      v-for="(item, index) in $store.state.bpo2.outputs.startupCosts.startupCosts"
                      :key="index"
                    >
                      <td>{{ item.name }}</td>
                      <td class="align-center">{{ item.amount | currency(0) }}</td>
                    </tr>

                    <tr class="subtotal1">
                      <td class="footer align-center"></td>
                      <td class="footer align-center">{{ $store.state.bpo2.outputs.startupCosts.total_W77 | currency(0) }}</td>
                    </tr>

                  </table>
                  <!-- STARTUP COSTS -->

                  <!-- PREPAIDS AND DEPOSITS -->
                  <p class="subtitle">Prepaids and Deposits</p>

                  <table>

                    <tr
                      v-for="(item, index) in $store.state.bpo2.outputs.prepaidsAndDeposits.prepaidsAndDeposits"
                      :key="index"
                    >
                      <td>{{ item.name }}</td>
                      <td class="align-center">{{ item.amount | currency(0) }}</td>
                    </tr>

                    <tr class="subtotal1">
                      <td class="footer align-center"></td>
                      <td class="footer align-center">{{ $store.state.bpo2.outputs.prepaidsAndDeposits.total_W89 | currency(0) }}</td>
                    </tr>

                  </table>
                  <!-- PREPAIDS AND DEPOSITS -->

                </div>

              </div>

            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Assumptions and Price Opinion</p>

              <table>

                <tr>
                  <td></td>
                  <td class="align-center column-header">{{ $store.state.bpo2.outputs.actuals.label_J38 }}</td>
                  <td class="align-center column-header">{{ $store.state.bpo2.outputs.brokers.label_K38 }}</td>
                  <td class="align-center column-header">Proforma<br />Year 1</td>
                  <td class="align-center column-header">Proforma<br />Year 2</td>
                  <td class="align-center column-header">Proforma<br />Year 3</td>
                </tr>

                <tr>
                  <td>Gross Rental Income</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.grossRentalIncome_J40 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.grossRentalIncome_K40 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.grossRentalIncome_L40 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.grossRentalIncome_M40 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.grossRentalIncome_N40 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Economic Vacancy</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.economicVacancy_J41 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.economicVacancy_K41 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.economicVacancy_L41 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.economicVacancy_M41 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.economicVacancy_N41 | currency(0) }}</td>
                </tr>

                <tr class="subline">
                  <td style="padding-left: 2em">Economic Vacancy Rate</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.economicVacancyRatePercent_J42 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.economicVacancyRatePercent_K42 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.economicVacancyRatePercent_L42 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.economicVacancyRatePercent_M42 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.economicVacancyRatePercent_N42 | percent(1) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td>Net Rental Income</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.netRentalIncome_J43 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.netRentalIncome_K43 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.netRentalIncome_L43 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.netRentalIncome_M43 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.netRentalIncome_N43 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Laundry</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.laundry_J44 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.laundry_K44 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.laundry_L44 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.laundry_M44 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.laundry_N44 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>RUBS</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.rubs | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.rubs | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.rubs | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.rubs | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.rubs | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Misc. Other Income</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.miscellaneousOtherIncome_J45 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.miscellaneousOtherIncome_K45 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.miscellaneousOtherIncome_L45 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.miscellaneousOtherIncome_M45 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.miscellaneousOtherIncome_N45 | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td>Total Net Income</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.totalNetIncome_J46 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.totalNetIncome_K46 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.totalNetIncome_L46 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.totalNetIncome_M46 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.totalNetIncome_N46 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Expenses per Unit</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.expensesPerUnit_J48 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.expensesPerUnit_K48 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.expensesPerUnit_L48 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.expensesPerUnit_M48 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.expensesPerUnit_N48 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Expenses per Sqft</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.expensesPerSqft_J49 | currency(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.expensesPerSqft_K49 | currency(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.expensesPerSqft_L49 | currency(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.expensesPerSqft_M49 | currency(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.expensesPerSqft_N49 | currency(2) }}</td>
                </tr>

                <tr>
                  <td>Expenses as % of Income</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.expensesAsPercentOfIncome_J50 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.expensesAsPercentOfIncome_K50 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.expensesAsPercentOfIncome_L50 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.expensesAsPercentOfIncome_M50 | percent(1) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.expensesAsPercentOfIncome_N50 | percent(1) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td>Total Expenses</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.totalExpenses_J51 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.totalExpenses_K51 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.totalExpenses_L51 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.totalExpenses_M51 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.totalExpenses_N51 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Net Operating Income</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.netOperatingIncome_J53 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.netOperatingIncome_K53 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.netOperatingIncome_L53 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.netOperatingIncome_M53 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.netOperatingIncome_N53 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Mortgage Interest</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.mortgageInterest_J55 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.mortgageInterest_K55 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.mortgageInterest_L55 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.mortgageInterest_M55 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.mortgageInterest_N55 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Capital Reserves/Unit</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.capitalReservesPerUnit_J57 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.capitalReservesPerUnit_K57 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.capitalReservesPerUnit_L57 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.capitalReservesPerUnit_M57 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.capitalReservesPerUnit_N57 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Capital Reserves</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.capitalReserves_J58 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.capitalReserves_K58 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.capitalReserves_L58 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.capitalReserves_M58 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.capitalReserves_N58 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal1">
                  <td>Pre-tax Profit</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.preTaxProfit_J60 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.preTaxProfit_K60 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.preTaxProfit_L60 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.preTaxProfit_M60 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.preTaxProfit_N60 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Pre-tax ROI</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.preTaxROI_J61 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.preTaxROI_K61 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.preTaxROI_L61 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.preTaxROI_M61 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.preTaxROI_N61 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Asset Management {{ $store.state.bpo2.outputs.assetManagementPercent_I63 | percent(2)}}</td>
                  <td class="align-center"></td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.assetManagement_K63 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.assetManagement_L63 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.assetManagement_M63 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.assetManagement_N63 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Prinipal Reduction</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.principalReduction_J64 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.principalReduction_K64 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.principalReduction_L64 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.principalReduction_M64 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.principalReduction_N64 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Debt Service</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.debtService_J65 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.debtService_K65 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.debtService_L65 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.debtService_M65 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.debtService_N65 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Debt Service Coverage Ratio</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.debtServiceCoverageRatio_J66 | number(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.debtServiceCoverageRatio_K66 | number(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.debtServiceCoverageRatio_L66 | number(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.debtServiceCoverageRatio_M66 | number(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.debtServiceCoverageRatio_N66 | number(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Net Cash Flow</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.netCashflowAnnual_J68 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.netCashflowAnnual_K68 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.netCashflowAnnual_L68 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.netCashflowAnnual_M68 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.netCashflowAnnual_N68 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Net ROI (cash-on-cash)</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.netROICashOnCash_J70 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.netROICashOnCash_K70 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.netROICashOnCash_L70 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.netROICashOnCash_M70 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.netROICashOnCash_N70 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Lead Investor Compensation {{ $store.state.bpo2.outputs.leadInvestorCompensationPercent_I72 | percent(2)}}</td>
                  <td class="align-center"></td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.leadInvestorCompensation_K72 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.leadInvestorCompensation_L72 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.leadInvestorCompensation_M72 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.leadInvestorCompensation_N72 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Net to Passives</td>
                  <td class="align-center"></td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.netToPassives_K73 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.netToPassives_L73 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.netToPassives_M73 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.netToPassives_N73 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Net ROI to Passives</td>
                  <td class="align-center"></td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.netROIToPassives_K74 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.netROIToPassives_L74 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.netROIToPassives_M74 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.netROIToPassives_N74 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Cap Rate / Cap Rate Projection</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.capRateProjection_J76 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.capRateProjection_K76 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.capRateProjection_L76 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.capRateProjection_M76 | percent(2) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.capRateProjection_N76 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal3">
                  <td>Price Opinion Projection</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.actuals.brokerPriceOpinionProjection_J78 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.brokers.brokerPriceOpinionProjection_K78 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear1.brokerPriceOpinionProjection_L78 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear2.brokerPriceOpinionProjection_M78 | currency(0) }}</td>
                  <td class="align-center">{{ $store.state.bpo2.outputs.proformasYear3.brokerPriceOpinionProjection_N78 | currency(0) }}</td>
                </tr>

              </table>

            </article>

            <article
              class="tile is-child notification"
              v-if="$store.state.bpo2.outputs.notes_H80"
            >

              <p class="subtitle">Notes</p>

              <div>
                <vue-editor
                  style="background-color: #ffffff; height: auto;"
                  v-model="$store.state.bpo2.outputs.notes_H80"
                  :editorOptions="editorSettings"
                ></vue-editor>
              </div>

            </article>

          </div>
        </div>

      </div>

    </div>

    <p class="disclaimer">DISCLAIMER: This represents an estimated sale price for this property. It is not the same as the opinion of value in an appraisal developed by a licensed appraiser under the Uniform Standards of Professional Appraisal Practice. LS Realty Advisors, Inc., and/or Lifestyles Realty, Inc., and/or Lifestyles Unlimited, Inc. have not verified the information and make no guarantee, warranty, or representation. This broker price opinion was either filled out by a Lifestyles representative or the potential buyer or other. Further investigation may be necessary as more information is made available. When more information is available the opinion may substantially change; the reader should be aware of the limited scope of this opinion.</p>

  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },

  data() {
    return {
      editorSettings: {
        modules: {
          toolbar: false
        }
      }
    };
  }
};
</script>

<style>
</style>
